<template>
  <div class="clientes-view">

    <!-- Intro: mensaje + foto -->
    <section class="clients-hero">
      <div class="clients-hero-text">
        <img src="/img/Logo.jpg" alt="Logo Tasoar" class="hero-logo">
        <h1>Nuestros Clientes, <span>Nuestro Compromiso</span></h1>
        <p>
          En <strong>TASOAR</strong>, cada proyecto que desarrollamos es una alianza basada
          en la <strong>confianza</strong>, la <strong>calidad</strong> y el <strong>cumplimiento</strong>.
        </p>
        <p>
          Agradecemos a nuestros clientes por ser parte de nuestro crecimiento y por
          permitirnos ser parte de sus logros.
        </p>
      </div>
      <div class="clients-hero-image">
        <img src="/img/cliente-banner.webp" alt="Equipo Tasoar supervisando una obra en construcción">
      </div>
    </section>

    <!-- Cuadrícula de clientes -->
    <section class="clients-grid-section">
      <div class="clients-grid-wrapper">
        <span class="clients-grid-label">Algunos de nuestros clientes</span>

        <div class="clients-grid">
          <div
            v-for="(client, index) in clients"
            :key="index"
            class="client-cell"
            :class="{ 'client-cta': client.cta }"
          >
            <p v-if="client.cta">{{ client.text }}</p>
            <template v-else>
              <img
                v-for="(logo, logoIndex) in client.logos"
                :key="logoIndex"
                :src="logo"
                :alt="client.name || 'Logo de cliente Tasoar'"
                :class="{ 'logo-half': client.logos.length > 1 }"
              >
            </template>
          </div>
        </div>
      </div>
    </section>

    <!-- Barra de valores -->
    <section class="clients-values-bar">
      <div class="values-bar-container">
        <div class="value-item">
          <i class="fa-solid fa-compass-drafting"></i>
          <div class="value-text">
            <strong>DISEÑAMOS</strong>
            <span>CON VISIÓN</span>
          </div>
        </div>
        <div class="value-item">
          <i class="fa-solid fa-helmet-safety"></i>
          <div class="value-text">
            <strong>CONSTRUIMOS</strong>
            <span>CON CALIDAD</span>
          </div>
        </div>
        <div class="value-item">
          <i class="fa-solid fa-clipboard-check"></i>
          <div class="value-text">
            <strong>CUMPLIMOS</strong>
            <span>CON RESPONSABILIDAD</span>
          </div>
        </div>
        <div class="value-item">
          <i class="fa-solid fa-handshake"></i>
          <div class="value-text">
            <strong>ENTREGAMOS</strong>
            <span>CON ORGULLO</span>
          </div>
        </div>
        <div class="values-bar-logo">
          <img src="/img/Logo.jpg" alt="Logo Tasoar">
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'ClientesView',
  data() {
    return {
      clients: [
        { cta: true, text: 'Nos encantaría tener a tu empresa aquí...' },
        { name: 'Starbucks', logos: ['/img/clientes/starbucksLogo.webp'] },
        { name: "P.F. Chang's y California Pizza Kitchen", logos: ['/img/clientes/pfchangsLogo.png', '/img/clientes/californiaPizza.png'] },
        { name: 'Andrea', logos: ['/img/clientes/andrea-logo.png'] },
        { name: 'Empeño Fácil', logos: ['/img/clientes/empenoLogo.png'] },
        { name: 'Industrias Boris', logos: ['/img/clientes/boris.png'] },
        { name: 'Vips y El Potón', logos: ['/img/clientes/VipsLogo.png', '/img/clientes/elportonLogo.png'] },
        { name: 'Italiannis', logos: ['/img/clientes/italiannisLogo.jpg'] },
        { name: 'Proan y Tracsa CAT', logos: ['/img/clientes/proan.jpg', '/img/clientes/tracsa.webp'] },
        { name: 'Sapal', logos: ['/img/clientes/sapal.png'] },
        { name: 'Sunglass Hut', logos: ['/img/clientes/sunglasshut.png'] },
        { name: 'Polímeros y derivados', logos: ['/img/clientes/polimeros.png'] }
      ]
    };
  }
};
</script>

<style scoped>
.clientes-view {
  color: #2c3e50;
}

/* --- Hero / Intro --- */
.clients-hero {
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  align-items: stretch;
  min-height: 500px;
}

.clients-hero-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 18px;
  padding: 60px 60px 60px 80px;
  background: linear-gradient(135deg, #eef3f9 0%, #dbe6f2 100%);
  text-align: left;
}

.hero-logo {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.clients-hero-text h1 {
  font-size: 2.4rem;
  line-height: 1.25;
  color: var(--color-primary);
  margin: 0;
  position: relative;
  padding-bottom: 20px;
}

.clients-hero-text h1::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 70px;
  height: 4px;
  background-color: var(--color-primary);
}

.clients-hero-text h1 span {
  display: block;
}

.clients-hero-text p {
  font-size: 1.05rem;
  line-height: 1.6;
  color: #333;
  margin: 0;
  max-width: 480px;
}

.clients-hero-text p strong {
  color: var(--color-primary);
}

.clients-hero-image {
  position: relative;
  overflow: hidden;
}

.clients-hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* --- Cuadrícula de clientes --- */
.clients-grid-section {
  background-color: #f4f8fc;
  padding: 0 20px 70px;
}

.clients-grid-wrapper {
  max-width: 1300px;
  margin: -30px auto 0 auto; /* Sube la cuadrícula para que se monte sobre el hero */
  position: relative;
}

.clients-grid-label {
  display: inline-block;
  background-color: var(--color-primary);
  color: #ffffff;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.95rem;
  padding: 12px 28px;
  border-radius: 8px 8px 0 0;
}

.clients-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  background-color: #ffffff;
  border-radius: 0 10px 10px 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.client-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 110px;
  padding: 18px;
  border: 1px solid #eaeef3;
}

.client-cell img {
  max-width: 100%;
  max-height: auto;
  width: auto;
  object-fit: contain;
}

/* Cuando hay 2 logos en la misma celda, se reducen a la mitad
   para que no compitan por el espacio y se vean encimados */
.client-cell img.logo-half {
  max-width: 50%;
  height: auto;
}

.client-cta {
  background-color: #f7f9fc;
}

.client-cta p {
  margin: 0;
  text-align: center;
  font-size: 0.95rem;
  color: #6c7a8c;
  font-style: italic;
  line-height: 1.4;
}

/* --- Barra de valores --- */
.clients-values-bar {
  background-color: var(--color-primary);
  padding: 30px 20px;
}

.values-bar-container {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.value-item {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1 1 200px;
  padding: 0 20px;
}

.value-item:not(:last-of-type) {
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.value-item i {
  font-size: 2rem;
  color: #ffffff;
  flex-shrink: 0;
}

.value-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.value-text strong {
  font-size: 0.85rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.value-text span {
  font-size: 0.75rem;
  color: #cfe0f5;
  font-weight: 500;
}

.values-bar-logo {
  margin-left: auto;
  flex: 0 0 auto;
}

.values-bar-logo img {
  height: 40px;
  width: auto;
  display: block;
}

/* --- Responsivo --- */
@media (max-width: 1100px) {
  .clients-hero-text {
    padding: 50px 40px;
  }

  .clients-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 900px) {
  .clients-hero {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .clients-hero-image {
    min-height: 280px;
    order: 2;
  }

  .clients-hero-text {
    order: 1;
    padding: 50px 30px 40px 30px;
    text-align: center;
    align-items: center;
  }

  .clients-hero-text h1::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .clients-hero-text p {
    max-width: 100%;
  }

  .clients-grid-wrapper {
    margin-top: 0;
  }

  .value-item:not(:last-of-type) {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 15px;
  }

  .values-bar-container {
    flex-direction: column;
    align-items: stretch;
  }

  .value-item {
    justify-content: center;
    text-align: center;
  }

  .value-text {
    text-align: center;
  }

  .values-bar-logo {
    margin: 10px auto 0 auto;
  }
}

@media (max-width: 640px) {
  .clients-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .client-cell {
    min-height: 90px;
    padding: 14px;
  }

  .client-cell img {
    height: auto;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .clients-hero-text h1 {
    font-size: 1.8rem;
  }

  .clients-grid-label {
    font-size: 0.8rem;
    padding: 10px 20px;
  }
}
</style>